// extracted by mini-css-extract-plugin
module.exports = {"description":"FundLaterReminderModal_description__3viX3","deposit":"FundLaterReminderModal_deposit__2R6AQ"};